export default {
    namespaced: true,
    state: {
        page: 1,
        purchaseMark: []
    },
    actions: {

    },
    mutations: {
        updatePagination(state, page) {
            state.page = page
        }
    }
}
